<template>
  <div class="col-sm-12 col-md-12 card-head">
    <h5 class="d-inline">
      {{ criteria.criterion_index }} &nbsp; {{ criteria.description }}
    </h5>
    <table class="table table-bordered">
      <thead class="card-print">
        <tr>
          <th>Id</th>
          <th>Obligation</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="indicator in criteria.control_points">
          <tr :key="indicator.control_point_id" class="m-t-10 card-print">
            <td class="text-left">
              {{ indicator.control_point_name }}
            </td>
            <td class="text-left">
              <span v-if="indicator.obligation === 'Major'">Major Must</span>
              <span v-if="indicator.obligation === 'Minor'">Minor Must</span>
            </td>
            <td class="text-left">
              {{ indicator["description"] }}
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Criteria',
  props: ['principleIndex', 'criteria'],
  methods: {
    getPityName(name) {
      return name.substring(name.indexOf(' '));
    }
  }
}
</script>

<style scoped>
</style>
